export interface Point {
  id: string;
  x: number;
  y: number;
}

export interface LinePath {
  lineId: string;
  pointIds: string[];
}

export interface AllDots {
  points: Point[];
  lines: LinePath[];
}

export const dotsData: Readonly<AllDots> = {
  points: [
    { id: "hardi", x: 240, y: 52 },
    { id: "wanti", x: 317, y: 42 },
    { id: "yoga", x: 389, y: 49 },
    { id: "tjipto", x: 449, y: 89 },
    { id: "woyo", x: 397, y: 120 },
    { id: "poniran", x: 332, y: 131 },
    { id: "purdiwiyono", x: 256, y: 128 },
    { id: "wignyo", x: 200, y: 96 },
    { id: "budhi", x: 145, y: 185 },
    { id: "inna", x: 291, y: 164 },
    { id: "uki", x: 418, y: 170 },
    { id: "yani", x: 488, y: 193 },
    { id: "ayu", x: 515, y: 266 },
    { id: "agung", x: 376, y: 332 },
    { id: "heru", x: 226, y: 332 },
    { id: "riyanto", x: 123, y: 271 },
    { id: "wahyu", x: 98, y: 349 },
    { id: "endah", x: 548, y: 355 },
    { id: "sinta", x: 626, y: 496 },
    { id: "moki", x: 337, y: 605 },
    { id: "dewi", x: 4, y: 498 },
    { id: "c201", x: 240, y: 196 },
    { id: "c202", x: 265, y: 209 },
    { id: "c203", x: 318, y: 185 },
    { id: "c204", x: 385, y: 195 },
    { id: "c205", x: 443, y: 235 },
    { id: "c206", x: 404, y: 265 },
    { id: "c207", x: 335, y: 274 },
    { id: "c208", x: 260, y: 272 },
    { id: "c209", x: 200, y: 238 },
    { id: "c301", x: 146, y: 391 },
    { id: "c302", x: 293, y: 372 },
    { id: "c303", x: 416, y: 376 },
    { id: "c304", x: 489, y: 401 },
    { id: "c305", x: 489, y: 456 },
    { id: "c306", x: 513, y: 472 },
    { id: "c307", x: 374, y: 538 },
    { id: "c308", x: 228, y: 537 },
    { id: "c309", x: 125, y: 481 },
    { id: "c310", x: 200, y: 440 },
  ],
  lines: [
    /*1*/
    { lineId: "l1_5", pointIds: ["hardi", "woyo"] },
    { lineId: "l1_6", pointIds: ["hardi", "poniran"] },
    { lineId: "l1_7", pointIds: ["hardi", "purdiwiyono"] },
    { lineId: "l1_8", pointIds: ["hardi", "wignyo"] },
    { lineId: "l1_9", pointIds: ["hardi", "c201", "budhi"] },
    { lineId: "l1_10", pointIds: ["hardi", "c201", "inna"] },
    { lineId: "l1_13", pointIds: ["hardi", "c201", "ayu"] },
    /*2*/
    { lineId: "l2_3", pointIds: ["wanti", "yoga"] },
    { lineId: "l2_4", pointIds: ["wanti", "tjipto"] },
    { lineId: "l2_8", pointIds: ["wanti", "wignyo"] },
    { lineId: "l2_12", pointIds: ["wanti", "c203", "yani"] },
    { lineId: "l2_16", pointIds: ["wanti", "c203", "riyanto"] },
    /*3*/
    { lineId: "l3_4", pointIds: ["yoga", "tjipto"] },
    { lineId: "l3_5", pointIds: ["yoga", "woyo"] },
    { lineId: "l3_6", pointIds: ["yoga", "poniran"] },
    { lineId: "l3_12", pointIds: ["yoga", "c204", "yani"] },
    { lineId: "l3_13", pointIds: ["yoga", "c204", "ayu"] },
    { lineId: "l3_15", pointIds: ["yoga", "c204", "heru"] },
    /*4*/
    { lineId: "l4_5", pointIds: ["tjipto", "woyo"] },
    { lineId: "l4_6", pointIds: ["tjipto", "poniran"] },
    { lineId: "l4_14", pointIds: ["tjipto", "c205", "agung"] },
    { lineId: "l4_15", pointIds: ["tjipto", "c205", "heru"] },
    /*5*/
    { lineId: "l5_6", pointIds: ["woyo", "poniran"] },
    { lineId: "l5_8", pointIds: ["woyo", "wignyo"] },
    { lineId: "l5_16", pointIds: ["woyo", "c206", "riyanto"] },
    /*6*/
    { lineId: "l6_7", pointIds: ["poniran", "purdiwiyono"] },
    { lineId: "l6_15", pointIds: ["poniran", "c207", "heru"] },
    /*7*/
    { lineId: "l7_8", pointIds: ["purdiwiyono", "wignyo"] },
    { lineId: "l7_10", pointIds: ["purdiwiyono", "c208", "inna"] },
    /*8*/
    { lineId: "l8_14", pointIds: ["wignyo", "c209", "agung"] },
    { lineId: "l8_21", pointIds: ["wignyo", "c310", "dewi"] },
    /*9*/
    { lineId: "l9_10", pointIds: ["budhi", "inna"] },
    { lineId: "l9_13", pointIds: ["budhi", "ayu"] },
    { lineId: "l9_15", pointIds: ["budhi", "heru"] },
    { lineId: "l9_16", pointIds: ["budhi", "riyanto"] },
    { lineId: "l9_17", pointIds: ["budhi", "c301", "wahyu"] },
    /*10*/
    { lineId: "l10_11", pointIds: ["inna", "uki"] },
    { lineId: "l10_12", pointIds: ["inna", "yani"] },
    { lineId: "l10_13", pointIds: ["inna", "ayu"] },
    { lineId: "l10_17", pointIds: ["inna", "c302", "wahyu"] },
    { lineId: "l10_18", pointIds: ["inna", "c302", "endah"] },
    /*11*/
    { lineId: "l11_12", pointIds: ["uki", "yani"] },
    { lineId: "l11_20", pointIds: ["uki", "c303", "moki"] },
    /*12*/
    { lineId: "l12_14", pointIds: ["yani", "agung"] },
    { lineId: "l12_19", pointIds: ["yani", "c304", "sinta"] },
    /*13*/
    { lineId: "l13_14", pointIds: ["ayu", "agung"] },
    { lineId: "l13_15", pointIds: ["ayu", "heru"] },
    { lineId: "l13_18", pointIds: ["ayu", "c306", "endah"] },
    { lineId: "l13_19", pointIds: ["ayu", "c306", "sinta"] },
    /*14*/
    { lineId: "l14_15", pointIds: ["agung", "heru"] },
    /*15*/
    { lineId: "l15_16", pointIds: ["heru", "riyanto"] },
    { lineId: "l15_21", pointIds: ["heru", "c308", "dewi"] },
    /*16*/
    /*17*/
    { lineId: "l17_18", pointIds: ["wahyu", "endah"] },
    { lineId: "l17_20", pointIds: ["wahyu", "moki"] },
    { lineId: "l17_21", pointIds: ["wahyu", "dewi"] },
    /*18*/
    { lineId: "l18_19", pointIds: ["endah", "sinta"] },
    { lineId: "l18_21", pointIds: ["endah", "dewi"] },
    /*19*/
    { lineId: "l19_20", pointIds: ["sinta", "moki"] },
    { lineId: "l19_21", pointIds: ["sinta", "dewi"] },
    /*20*/
    { lineId: "l20_21", pointIds: ["moki", "dewi"] },
    /*21*/
  ],
};

enum themeColours {
  sounds = "#36475c",
  evacuation = "#a33a4a",
  shelters = "#729fba",
  assistance = "#6b9061",
  communication = "#dcbd54",
  ash = "#af8087",
  spiritualism = "#e49073",
  movingon = "#bcac96",
}

export const getThemeColour = (themeId: string): string =>
  themeColours[themeId];
